import Streaming from "../streaming/streaming";
import {initTopBottom} from "../modulos/topbottom/topbottom";
import analisisMasVistos from "../modulos/analisisMasVistos/analisisMasVistos";
import instrumentBox from "../modulos/instrumentBox/instrumentBox";
import {infiniteScrollDetect} from "../modulos/infiniteScrolling/detectAndLoadInfiniteScrolling";
import importantQuotes from "../modulos/importantQuotes/importantQuotes";

export const especialesTagPage = () => {
    //Inicializa los módulos de top/flops
    initTopBottom(Streaming);

    //Módulo de análisis más vistos
    analisisMasVistos();

    //Scroll Infinito
    infiniteScrollDetect();

    //Cargar solo el instrumentBox si se detecta el cuadro
    if (document.querySelector('.md-ibex-rates')) {
        instrumentBox(Streaming);
    }
    //Cargar md-ticker (antigua marquesina) si se detecta (en crypto se usa)
    if (document.querySelector('.md-ticker-holder')) {
        importantQuotes(Streaming);
    }
}
